import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  FormFeedback,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import CardPaymentService from "../../../services/OrderingServices/CardPaymentService";
import Select from "react-select";

const StatusModal = ({ isOpen, toggle, selectedCard, fetchCardAssign }) => {
  const status = [
    { label: "Issued", value: 1 },
    { label: "Active", value: 2 },
    { label: "Suspended", value: 3 },
    { label: "Lost", value: 4 },
    { label: "Damaged", value: 5 },
    { label: "Replaced", value: 6 },
    { label: "Expired", value: 7 },
  ];

  const statusMap = {
    Issued: 1,
    Active: 2,
    Suspended: 3,
    Lost: 4,
    Damaged: 5,
    Replaced: 6,
    Expired: 7,
  };

  const formik = useFormik({
    initialValues: {
      status: statusMap[selectedCard?.status] ?? null,
      reason: "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      status: Yup.number().required("Status is required"),
      reason: Yup.string().required("Reason is required"),
    }),
    onSubmit: async (values) => {
      try {
        const res = await CardPaymentService.status(
          selectedCard?.cardUid,
          values,
        );
        toast.success("Status changed successfully");
        fetchCardAssign();
        toggle();
      } catch (error) {
        toast.error(error.message);
      }
    },
  });

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Change Card Status</ModalHeader>
      <ModalBody>
        <form onSubmit={formik.handleSubmit}>
          <FormGroup>
            <Label>Status</Label>
            <Select
              options={status}
              value={status.find((s) => s.value === formik.values.status)}
              onChange={(opt) => formik.setFieldValue("status", opt.value)}
            />
            {formik.errors.status && (
              <FormFeedback style={{ display: "block" }}>
                {formik.errors.status}
              </FormFeedback>
            )}
          </FormGroup>

          <FormGroup>
            <Label>Reason</Label>
            <Input
              type="textarea"
              {...formik.getFieldProps("reason")}
              invalid={formik.touched.reason && !!formik.errors.reason}
            />
            <FormFeedback>{formik.errors.reason}</FormFeedback>
          </FormGroup>

          <ModalFooter>
            <Button color="secondary" onClick={toggle}>
              Cancel
            </Button>
            <Button color="primary" type="submit">
              Change Status
            </Button>
          </ModalFooter>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default StatusModal;
